import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HERO_BG = "https://images.unsplash.com/photo-1643126484644-3b9de6860ad6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

const galleryImages = [
  {
    url: "https://images.unsplash.com/photo-1762810981576-1b07f76af9d2?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Modern house with professionally landscaped driveway",
    category: "Landscaping",
  },
  {
    url: "https://images.pexels.com/photos/6728919/pexels-photo-6728919.jpeg?auto=compress&cs=tinysrgb&w=800",
    alt: "Professional lawn mowing in sunlit garden",
    category: "Lawn Care",
  },
  {
    url: "https://images.unsplash.com/photo-1768699107110-262fafb19b3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Snow removal from residential driveway",
    category: "Snow Removal",
  },
  {
    url: "https://images.unsplash.com/photo-1772040942277-b194d9d0b648?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Beautifully maintained garden deck",
    category: "Deck & Outdoor",
  },
  {
    url: "https://images.unsplash.com/photo-1759355787118-7b48305965d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Manicured hedges and garden front yard",
    category: "Landscaping",
  },
  {
    url: "https://images.unsplash.com/photo-1763025589551-06156a1ab9e1?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Colorful garden planting and flower beds",
    category: "Planting",
  },
  {
    url: "https://images.unsplash.com/photo-1704457031745-fe39ed2d296c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Modern residential property with large yard",
    category: "Landscaping",
  },
  {
    url: "https://images.unsplash.com/photo-1731082686849-d2e0a4d2c70c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Professional grass cutting service",
    category: "Lawn Care",
  },
  {
    url: "https://images.unsplash.com/photo-1763222208594-58426d30d3c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Stone house with manicured front lawn",
    category: "Landscaping",
  },
  {
    url: "https://images.unsplash.com/photo-1589689031305-4567c965ec47?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Mulched garden pathway and bed edging",
    category: "Mulching",
  },
  {
    url: "https://images.unsplash.com/photo-1775574993207-d872f8ab14f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Winter property with snow-covered trees",
    category: "Snow Removal",
  },
  {
    url: "https://images.unsplash.com/photo-1759069953255-5c8f9f9912b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Sunlit garden path through lush greenery",
    category: "Landscaping",
  },
];

export default function Gallery() {
  return (
    <main data-testid="gallery-page">
      {/* Hero */}
      <section
        className="relative min-h-[45vh] flex items-center justify-center overflow-hidden"
        style={{ paddingTop: "80px" }}
      >
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url('${HERO_BG}')` }}
        />
        <div className="absolute inset-0 bg-black/55" />
        <div className="relative z-10 text-center px-4 py-16">
          <span
            className="inline-block mb-3 px-4 py-1.5 bg-[#8dc63f]/20 text-[#8dc63f] text-xs font-semibold rounded-full uppercase tracking-widest border border-[#8dc63f]/30"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Our Portfolio
          </span>
          <h1
            className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mt-3"
            style={{ fontFamily: "'Outfit', sans-serif", textShadow: "0 2px 20px rgba(0,0,0,0.4)" }}
          >
            Gallery
          </h1>
          <p className="text-white/80 text-base mt-4 max-w-xl mx-auto">
            Explore our portfolio of residential landscaping transformations across Mississauga and the GTA
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 md:py-28 bg-[#F9F8F6]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2
              className="text-2xl sm:text-3xl font-bold text-[#1F291E]"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Transformations We're Proud Of
            </h2>
            <p className="text-[#4A5D48] text-base mt-3 max-w-xl mx-auto">
              From lush green lawns to pristine winter driveways — quality work speaks for itself.
            </p>
          </div>

          {/* Masonry grid */}
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 space-y-5">
            {galleryImages.map((img, idx) => (
              <div
                key={idx}
                data-testid={`gallery-item-${idx}`}
                className="gallery-item break-inside-avoid group relative overflow-hidden rounded-2xl shadow-sm"
              >
                <img
                  src={img.url}
                  alt={img.alt}
                  className="w-full h-auto object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-end p-4 opacity-0 group-hover:opacity-100">
                  <span
                    className="bg-[#8dc63f] text-[#1F291E] text-xs font-semibold px-3 py-1.5 rounded-lg"
                    style={{ fontFamily: "'Outfit', sans-serif" }}
                  >
                    {img.category}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section
        className="py-16 text-center"
        style={{ background: "linear-gradient(135deg, #3a5c2e 0%, #2d4a24 100%)" }}
      >
        <div className="max-w-2xl mx-auto px-4">
          <h2
            className="text-2xl sm:text-3xl font-bold text-white mb-4"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Like What You See?
          </h2>
          <p className="text-white/80 text-sm mb-7">
            Let us transform your property. Get a free estimate today and join our growing list of satisfied clients.
          </p>
          <Link
            to="/contact"
            data-testid="gallery-cta-btn"
            className="btn-accent px-8 py-3.5 rounded-xl text-sm inline-flex items-center gap-2"
          >
            Request a Free Quote <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </main>
  );
}
